import { Tooltip } from "antd";
import { createStyles } from "antd-style";

import { Typography } from "@av/components/atoms/typography/Typography";

const TRAILING_FILENAME_CHARACTER_COUNT = 16;

const useStyles = createStyles(({ css, token }) => ({
  fileName: css`
    display: grid;
    grid-template-columns: minmax(0, max-content) max-content;
    min-width: 0;
    flex: 1 1 auto;
    color: ${token.colorPrimary};
  `,
  leadingText: css`
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  trailingText: css`
    white-space: nowrap;
  `,
}));

type MiddleEllipsisFileNameProps = {
  fileName: string;
  testIdPrefix: string;
  className?: string;
};

export function MiddleEllipsisFileName({
  fileName,
  testIdPrefix,
  className,
}: MiddleEllipsisFileNameProps) {
  const { styles, cx } = useStyles();
  const trailingTextStart = Math.max(0, fileName.length - TRAILING_FILENAME_CHARACTER_COUNT);

  return (
    <Tooltip title={fileName} trigger={["hover", "focus"]}>
      <Typography.Text
        aria-label={fileName}
        className={cx(styles.fileName, className)}
        tabIndex={0}
        testIdPrefix={testIdPrefix}
      >
        <span className={styles.leadingText}>{fileName.slice(0, trailingTextStart)}</span>
        <span className={styles.trailingText}>{fileName.slice(trailingTextStart)}</span>
      </Typography.Text>
    </Tooltip>
  );
}
